





























import { Component, Vue, Prop } from 'vue-property-decorator';
import { HSLColor } from '../types/color';
import { hslToHex, hslToRgb } from '../utilities/colorConversion';
/* eslint no-mixed-operators: "off" */

@Component
export default class Converter extends Vue {
  @Prop() picked!: HSLColor;

  get hex() {
    return hslToHex(this.picked);
  }

  get rgb() {
    const color = hslToRgb(this.picked);
    return `rgb(${color.r},${color.g},${color.b})`;
  }
}
